import { Instance } from 'mobx-state-tree'
import { ModuleStatModelBase } from './ModuleStatModel.base'

/* The TypeScript type of an instance of ModuleStatModel */
export interface ModuleStatModelType extends Instance<typeof ModuleStatModel.Type> {}

/* A graphql query fragment builders for ModuleStatModel */
export { selectFromModuleStat, moduleStatModelPrimitives, ModuleStatModelSelector } from './ModuleStatModel.base'

/**
 * ModuleStatModel
 */
export const ModuleStatModel = ModuleStatModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
